import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateBaptismInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    baptized: '',
    date_of_baptism: '',
    parish_of_baptism: '',
    godparent_name: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        baptized: christian.baptized || '',
        date_of_baptism: christian.date_of_baptism || '',
        parish_of_baptism: christian.parish_of_baptism || '',
        godparent_name: christian.godparent_name || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        formData
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating baptism info:", error);
      alert("Failed to update baptism info. Check console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.baptized}
          </label>
          <select
            name="baptized"
            value={formData.baptized}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select baptism status</option>
            <option value="Yego">Baptized</option>
            <option value="Oya">Not Baptized</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.dobaptize}
          </label>
          <input
            type="date"
            name="date_of_baptism"
            value={formData.date_of_baptism}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.parish_of_baptism}
          </label>
          <input
            type="text"
            name="parish_of_baptism"
            value={formData.parish_of_baptism}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.godparent}
          </label>
          <input
            type="text"
            name="godparent_name"
            value={formData.godparent_name}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateBaptismInfo;